import { createFileRoute } from "@tanstack/react-router";

import CompetitionEntries from "@/components/CompetitionEntries/CompetitionEntries";

const Component = () => {
  const competitionUuid = Route.useParams().competitionUuid;
  return <CompetitionEntries competitionUuid={competitionUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/events/$competitionUuid/competitors")({
  component: Component,
});
